<script>
    import { temp, feverDetected, primaryColor } from '../../store.js'
    import { Jellyfish, Wave } from 'svelte-loading-spinners'

    let state = 'requestConnect', fnError
    async function connectDevice() {
        try {
            let device = await navigator.bluetooth.requestDevice({ filters: [{ services: ['00001809-0000-1000-8000-00805f9b34fb'] }] })
            state = 'connecting'
            let server = await device.gatt.connect()
            let service = await server.getPrimaryService('00001809-0000-1000-8000-00805f9b34fb')
            let characteristic = await service.getCharacteristic('00002a1e-0000-1000-8000-00805f9b34fb')
            characteristic.addEventListener('characteristicvaluechanged', handleCharacteristicValueChanged);
            let notifs = characteristic.startNotifications()
            state = 'measuring'
        } catch(error) {
            state = 'isError'
            alert(error)
            console.log(error);
            fnError = error
        }
    }

    let myTemp = 0, tempArray = [], finalReading, isFever
    function handleCharacteristicValueChanged(event) {
        let value = event.target.value;
        let a = value.getUint8(10)
        let b = value.getUint8(11)
        let currentTemp = (a+(b*256))/100
        myTemp = currentTemp
        tempArray.push(currentTemp)
        if (tempArray.length > 12) {
            tempArray.shift()
            const allEqual = tempArray.every(v => v === tempArray[0])
            if(allEqual === true) {
                finalReading = currentTemp
                if (finalReading > 37.5) {
                    isFever = true
                    feverDetected.set('true')
                } else {
                    isFever = false
                }
                temp.set(finalReading)
                state = 'finished'
            }
        }
    }
</script>

<main>
    <div class="body">
        {#if state === 'requestConnect'}
        <img src="/img/thermo.png"/>
        <h1 class="text-primary">Connect Your Thermometer</h1>
        <h3>1. Remove the thermometer from its cover. It should turn on automatically.</h3>
        <p>Tanggalin ang pantakip ng thermometer. Dapat mag-on ito nang kusa.</p>
        <h3>2. Press "Connect" and select the device <span class="text-primary ul">MMC-W505</span></h3>
        <p>Pindutin ang "Connect" at piliin ang <span class="text-primary ul">MMC-W505</span></p>
        <a class="btn btn-primary" on:click={connectDevice}>Connect</a>
        {/if}

        {#if state === 'connecting'}
        <Jellyfish size="69" color={$primaryColor} unit="px"></Jellyfish>
        <h1>Connecting...</h1>
        {/if}

        {#if state === 'measuring'}
        <Wave size="58" color={$primaryColor} unit="px"></Wave>
        <h1>Take your temperature</h1>
        <p>Kunin ang iyong temperatura</p>
        <span class="currentTemp">{myTemp}°C</span>
        {/if}

        {#if state === 'finished'}
        <p>Your Temperature</p>
        <h1 class="text-primary">{finalReading}°C</h1>

            {#if !isFever}
            <p>Safe to work. Please observe health safety precautions.</p>
            <a class="btn btn-primary" href="/name">Next</a>
            {/if}

            {#if isFever}
            <p>⚠️ It looks like you have a fever. Please seek medical advice. Do not report to work.</p>
            <a class="btn btn-primary" href="/name">Proceed to Checkup</a>
            {/if}

        {/if}

        {#if state === 'isError'}
        <pre>{fnError}</pre>
        {/if}
    </div>
</main>

<style>
    pre {
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
    }

    .ul {
        text-decoration: underline;
    }

    .currentTemp {
        font-size: 58px;
        font-weight: 400;
        color: #e8e8e8;
    }

    .body {
        padding-bottom: 72px;
    }
</style>